export default "__VITE_ASSET__8dbeeaf8__"